// Helpers for attachment URLs: Cloudinary uploads, inline data: URLs (local development
// without Cloudinary) and pasted links.

export const isImage = (url: string) => /^data:image\//.test(url) || /\.(png|jpe?g|webp|gif|heic|heif)(\?|$)/i.test(url);
export const isPdf = (url: string) => /^data:application\/pdf/.test(url) || /\.pdf(\?|$)/i.test(url);

export function fileName(url: string): string {
  if (url.startsWith("data:")) return "archivo";
  try {
    return decodeURIComponent(new URL(url).pathname.split("/").pop() || url);
  } catch {
    return url;
  }
}

/** "PDF", "DOCX"… for the placeholder tile of a file without a preview. */
export function fileExt(url: string): string {
  const m = url.startsWith("data:") ? url.match(/^data:[^/]+\/([\w.+-]+)/) : url.match(/\.(\w{1,5})(\?|$)/);
  return m ? m[1].toUpperCase().replace(/^JPEG$/, "JPG") : "";
}

/**
 * A small square preview of an attachment, or null when there is none to show (Word files,
 * links to other sites). Cloudinary builds it on the fly: photos are cropped to fit and
 * served as JPG (so iPhone HEIC photos show in every browser), and a PDF shows the top of
 * its first page.
 */
export function thumbnailUrl(url: string, size = 160): string | null {
  const m = url.match(/^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)\.(\w+)$/i);
  if (m) {
    const pdf = m[3].toLowerCase() === "pdf";
    if (!pdf && !isImage(url)) return null;
    return `${m[1]}${pdf ? "pg_1,g_north," : ""}c_fill,w_${size},h_${size}/${m[2]}.jpg`;
  }
  return isImage(url) && !/\.(heic|heif)(\?|$)/i.test(url) ? url : null;
}
